import ReactMarkdown from 'react-markdown';
const Service = () => {
  const content = `

  # Terms of Service
  
  **Last Updated:** January 14, 2026
  
  These Terms of Service (“**Terms**”) govern your access to and use of the SolveClip website and services (collectively, the “**Service**”), operated by **Littlelights US Corporation** (“**SolveClip**”, “**we**”, “**our**”, or “**us**”).
  
  By accessing or using the Service, you agree to be bound by these Terms.
  
  If you do not agree, you may not use the Service.
  
  ---
  
  ## 1. Description of the Service
  
  SolveClip is an AI-powered platform that allows users to generate explanatory videos based on text and image inputs provided by the user.
  
  The Service is provided for informational and educational purposes only.
  
  ---
  
  ## 2. Eligibility
  
  You must be at least **13 years old** to use the Service.
  
  By using SolveClip, you represent and warrant that you meet this requirement and have the legal capacity to enter into these Terms.
  
  ---
  
  ## 3. User Accounts
  
  Some features of the Service require user registration.
  
  You agree to:
  
  - Provide accurate and complete account information
  - Maintain the confidentiality of your login credentials
  - Be responsible for all activities that occur under your account
  
  We reserve the right to suspend or terminate accounts that violate these Terms.
  
  ---
  
  ## 4. User Content
  
  ### 4.1 Ownership
  
  You retain ownership of any text or image content you submit to SolveClip (“**User Content**”).
  
  ### 4.2 License to Operate the Service
  
  By submitting User Content, you grant SolveClip a **limited, non-exclusive, non-transferable license** to process the content solely for the purpose of generating the requested video.
  
  We do **not** claim ownership over your User Content.
  
  ### 4.3 Content Responsibility
  
  You agree not to submit content that:
  
  - Is illegal, harmful, or abusive
  - Infringes intellectual property or privacy rights
  - Contains malware, deceptive, or malicious material
  
  SolveClip does not actively review all User Content but reserves the right to remove or restrict content that violates these Terms or applicable laws.
  
  ---
  
  ## 5. AI-Generated Content Disclaimer
  
  Videos generated by SolveClip are created using artificial intelligence and may contain errors, omissions, or inaccuracies.
  
  You acknowledge that:
  
  - AI-generated content is provided **“as is”**
  - SolveClip does not guarantee accuracy, completeness, or suitability for any specific purpose
  - You are responsible for reviewing and verifying outputs before relying on them
  
  ---
  
  ## 6. Acceptable Use
  
  You agree not to:
  
  - Use the Service for unlawful purposes
  - Attempt to reverse engineer, disrupt, or overload the Service
  - Bypass access controls or security measures
  - Use automated systems to abuse or scrape the Service
  
  We reserve the right to take appropriate action in response to misuse.
  
  ---
  
  ## 7. Intellectual Property
  
  All rights, title, and interest in the Service, including software, design, branding, and underlying technology, are owned by **Littlelights US Corporation** or its licensors.
  
  These Terms do not grant you any rights to our trademarks or proprietary assets.
  
  ---
  
  ## 8. Termination
  
  We may suspend or terminate your access to the Service at any time, with or without notice, if:
  
  - You violate these Terms
  - Your use poses a legal or security risk
  - The Service is discontinued
  
  You may stop using the Service at any time.
  
  ---
  
  ## 9. Disclaimer of Warranties
  
  THE SERVICE IS PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS.
  
  TO THE MAXIMUM EXTENT PERMITTED BY LAW, SOLVECLIP DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
  
  ---
  
  ## 10. Limitation of Liability
  
  TO THE MAXIMUM EXTENT PERMITTED BY LAW, SOLVECLIP SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR EXEMPLARY DAMAGES ARISING FROM YOUR USE OF THE SERVICE.
  
  IN NO EVENT SHALL OUR TOTAL LIABILITY EXCEED THE AMOUNT PAID BY YOU (IF ANY) TO USE THE SERVICE.
  
  ---
  
  ## 11. Governing Law
  
  These Terms shall be governed by and construed in accordance with the laws of the **United States**, without regard to conflict of law principles.
  
  ---
  
  ## 12. Changes to These Terms
  
  We may update these Terms from time to time.
  
  Continued use of the Service after changes become effective constitutes acceptance of the updated Terms.
  
  ---
  
  ## 13. Contact Information
  
  If you have any questions about these Terms, please contact us at:
  
  **Littlelights US Corporation**
  
  📧 Email:`;
  return (
    <div className="markdown-body">
      <ReactMarkdown>{content}</ReactMarkdown>
    </div>
  );
};
export default Service;
